var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.6 63.7999L140.5 121.7C140.462 122.173 140.331 122.634 140.114 123.057C139.897 123.479 139.599 123.855 139.237 124.162C138.874 124.468 138.455 124.7 138.002 124.844C137.55 124.988 137.073 125.041 136.6 125L84.9999 120.5C84.0354 120.399 83.1491 119.923 82.532 119.175C81.9148 118.427 81.616 117.466 81.6999 116.5L87.4999 49.4999C87.6011 48.5354 88.077 47.6491 88.8251 47.032C89.5732 46.4148 90.5337 46.116 91.4999 46.1999L134.5 49.8999L145.6 63.7999Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.7 38.7L92.8 39.9L91.6 26L106.7 38.7Z",
    fill: "#DB6C2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.7 38.7L92.8 39.9L91.6 26L106.7 38.7Z",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2 80C30.6735 80 34.3 76.3736 34.3 71.9001C34.3 67.4265 30.6735 63.8 26.2 63.8C21.7265 63.8 18.1 67.4265 18.1 71.9001C18.1 76.3736 21.7265 80 26.2 80Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.8 38.8999L105.2 42.9999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.2 88.5L103.6 86.7L112.8 76.3L116.8 82.3L119.1 79.9L124.2 88.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.6 74.0001C125.54 74.4455 125.351 74.8636 125.056 75.2026C124.761 75.5417 124.373 75.787 123.94 75.908C123.507 76.0291 123.049 76.0207 122.621 75.8839C122.192 75.7471 121.814 75.4879 121.531 75.1382C121.249 74.7886 121.075 74.3639 121.032 73.9166C120.988 73.4693 121.076 73.019 121.286 72.6213C121.495 72.2237 121.816 71.8961 122.21 71.679C122.603 71.462 123.052 71.365 123.5 71.4001C124.119 71.4755 124.685 71.7891 125.077 72.2745C125.469 72.7598 125.657 73.3788 125.6 74.0001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8001 103.5L55 105.2C54.0339 105.284 53.0733 104.985 52.3252 104.368C51.5771 103.751 51.1013 102.864 51 101.9L45.2 34.9C45.1161 33.9338 45.4149 32.9732 46.0321 32.2251C46.6493 31.477 47.5355 31.0012 48.5 30.9L91.5 27.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1 76.5L78.5 74.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7 83.4999L77.5999 81.8999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4 90.4L76.3 89",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6 53.1001L79.7 51.1001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2 60.2001L78.5 58.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1 112.6L24.5 122.3C24.0469 122.436 23.5711 122.479 23.1011 122.425C22.6311 122.372 22.1768 122.224 21.7656 121.991C21.3543 121.757 20.9947 121.442 20.7084 121.066C20.4222 120.689 20.2152 120.259 20.1 119.8L2.59999 54.7001C2.38423 53.773 2.53402 52.7985 3.01824 51.979C3.50246 51.1596 4.28386 50.5582 5.19999 50.3L38.8 41.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 93.3L42.4 88.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 100.1L42.7 95.3999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 106.8L42.7 102.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 63.9001L133.6 62.7001L134.8 48.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2 101.5L131 104.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6 108.4L125.8 111.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1427 64.6704L96.7808 91.6672L130.323 94.6018L132.685 67.6049L99.1427 64.6704Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesPhoto);
export default __webpack_public_path__ + "static/media/pages_photo.de0bebbcbea58cfbfd40bb4e3b9e9754.svg";
export { ForwardRef as ReactComponent };